import {BidConfig, BidderViewMode} from "../bid/bidding_model";


export enum Eligibility {
    Closed = 'Closed',
    InviteOnly = 'InviteOnly',

    OnRequest = 'OpenOnRequest',
    OpenToAll = 'OpenToAll',

}



export type RoundModel = {
    id: string;
    project_id: string;

    name: string | null;
    instructions: string | null;

    start_date: string;         // ISO date string
    end_date: string | null;    // ISO date string
    bid_config: BidConfig // = Field(default_factory=BidConfig)
    eligibility: Eligibility

    index: number; // = Field(default=0)
    created_at: string; //  datetime = Field(default_factory=datetime.now)
    //
    see_status_before_submission: boolean;
}

export type CreateRound = {

    name: string | null;

    start_date: string | null;   //  datetime = Field(default_factory=datetime.now)
    end_date: string | null;     // Union[datetime, None] = Field(default=None)

    bid_config: BidConfig        // = Field(default_factory=BidConfig)
    eligibility: Eligibility

    instructions: string | null;
    index: number; // = Field(default=0)


}

// export type UpdateRounds = keyof RoundModel | `bid_config`: | `bid_config.bid_view_mode.${keyof BidderViewMode}`;

